import { object, ref, string } from 'yup';

import 'web-shared/config/yup-config';
import { PASSWORD_VALIDATION_REGEX } from 'web-shared/consts/password-validation';
import { getFormFieldNameGenerator } from 'web-shared/utils/form';

export interface ResetPasswordFormValues {
  password: string;
  password_confirmation: string;
}

export const resetPasswordFieldNameGenerator = getFormFieldNameGenerator<ResetPasswordFormValues>();

const { n } = resetPasswordFieldNameGenerator;

export const initialValues: ResetPasswordFormValues = {
  password: '',
  password_confirmation: '',
};

export const validationSchema = object().typedShape<ResetPasswordFormValues>({
  password: string().required().matches(PASSWORD_VALIDATION_REGEX, 'validation_invalid_password_format'),
  password_confirmation: string().oneOf([ref(n('password'))], 'validation_password_dont_match').required(),
});
